import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../context/occ/hooks/use-i18n';
import { DisplayTextParagraph } from './subcomponents/paragraph';
import { DisplayTextPart } from './subcomponents/part';
import { getParagraphs } from './utils/get-paragraphs';
import { hasNewline } from './utils/has-new-line';
const b = bemClassBuilder('v-display-text');
/**
 * Renders a display text with interactive parts.
 */
export const DisplayText = observer(props => {
    const i18n = useI18n();
    const { label, templateParameters, className, internalActions, templateOptions } = props;
    if (!label)
        return null;
    const formattedLabel = i18n.displayTextLabel(label, templateParameters || {}, templateOptions);
    return _jsx("div", { className: b.block(undefined, className), children: getParts(formattedLabel, internalActions) });
});
DisplayText.displayName = 'DisplayText';
const getParts = (label, internalActions) => {
    if (!label)
        return null; // TODO: Fix type. #286586
    if (hasNewline(label)) {
        const paragraphs = getParagraphs(label);
        return paragraphs.map((paragraph, index) => (_jsx(DisplayTextParagraph, { paragraph: paragraph, internalActions: internalActions }, index)));
    }
    if (!Array.isArray(label)) {
        return _jsx(DisplayTextPart, { part: label, internalActions: internalActions });
    }
    return label.map((part, index) => _jsx(DisplayTextPart, { part: part, internalActions: internalActions }, index));
};
//# sourceMappingURL=display-text.js.map